import { uniqBy } from "lodash-es";

import { installedItems } from "../../../install/installed.ts";
import type { AwsIntegration } from "./types.ts";

export const existingIamWriteAndAssessmentItems = (config: AwsIntegration) => {
  const existingWrite = installedItems("iam-write", config);
  const existingAssessment = installedItems("iam-assessment", config);
  return uniqBy(
    [...Object.entries(existingWrite), ...Object.entries(existingAssessment)],
    ([id]) => id
  );
};

export const existingIamWriteItems = (config: AwsIntegration) => {
  const existingWrite = installedItems("iam-write", config);
  return uniqBy(Object.entries(existingWrite), ([id]) => id);
};
